import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { formatDateLong, isEmptyArray } from '../../common/util.services';
import { getCostingHistory } from '../amazon.services';
import '../amazon.scss'

const AmazonCostingHistory = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [costingData, setCostingData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'date', headerName: 'Date', filterable: false, sortable: false, editable: false, width: 200,
      valueFormatter: (date: any) => formatDateLong(date)
    },
    { field: 'prdCost', headerName: 'Product Cost', filterable: false, sortable: false, editable: false, width: 110},
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getCostingHistory(props.sku, page, pageSize, appContext,
        (response: any) => {
          setCostingData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={costingData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} showApproveAction={false} showDeleteAction={false} showAddBtn={false} 
        getRowId={(row: any) => row.date} maxHeight={450}/>
    </>
  }

  return <TitlePanel title='' panelBody={getMainPanel()} />
}

export default AmazonCostingHistory;